'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { Volume2, VolumeX } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useRef, useState } from 'react'
import { Logo } from './logo'

export function HeroSection() {
  const [isMuted, setIsMuted] = useState(true)
  const videoRef = useRef<HTMLVideoElement>(null)
  const t = useTranslations('landing_supplier.hero')

  const toggleSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted
      setIsMuted(!isMuted)
    }
  }
  return (
    <section
      className='overflow-hidden bg-black bg-[url("https://mcdn.coolmate.me/image/June2025/mceclip40_99.png")] bg-right-top bg-no-repeat px-5 py-10 text-white backdrop-blur-sm md:px-16'
      style={{
        backgroundSize: '400px',
      }}
    >
      <div className='flex items-end gap-2 text-lg uppercase tracking-wider md:text-2xl'>
        <Logo width={60} height={57} color='white' />
        {t('story')}
      </div>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:items-center'>
        <div className='font-criteria text-3xl font-bold italic tracking-tight sm:text-4xl md:!leading-[90px] lg:text-7xl'>
          {t.rich('headline', {
            br: () => <br className='hidden 2xl:block' />,
          })}
        </div>
        <div className='text-sm max-md:text-justify md:text-lg'>
          {t.rich('intro', {
            br: () => <br />,
          })}
        </div>
      </div>
      <div className='relative'>
        <video
          ref={videoRef}
          className='mt-6 w-full'
          loop
          playsInline
          muted
          autoPlay
          aria-label={t('video_aria_label')}
          poster={ImageHelper.getImageUrlCdn(
            '/image/December2023/mceclip0_71.png'
          )}
        >
          <source
            src='https://mcdn.coolmate.me/uploads/videos/xuong-may.mp4'
            type='video/mp4'
          />
        </video>
        <button
          onClick={toggleSound}
          className='absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70'
          aria-label={isMuted ? t('unmute') : t('mute')}
        >
          {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
        </button>
      </div>
      <div className='flex items-center justify-center'>
        <div className='mt-6 text-sm max-md:text-justify md:max-w-7xl md:text-center md:text-lg'>
          {t('proud')}
        </div>
      </div>
    </section>
  )
}
